import { render, staticRenderFns } from "./WorkIconElectricMagnifier.vue?vue&type=template&id=881c893c"
import script from "./WorkIconElectricMagnifier.vue?vue&type=script&lang=js"
export * from "./WorkIconElectricMagnifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports